module.exports = __webpack_public_path__ + "886c4369654282d3aefb63ef69936c83.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-23.png
// module id = 3251
// module chunks = 0